export const Skeleton = ({ className }: { className?: string }) => (
  <span
    aria-hidden="true"
    className={['block motion-safe:animate-pulse rounded-md bg-line', className]
      .filter(Boolean)
      .join(' ')}
  />
);
